import type { ABTests, FiverrContext } from '@fiverr-private/fiverr_context';
import {
    FULLY_TRACKED_EXPERIMENTS,
    MIXPANEL_RECORD_SESSION_PERCENT,
    MIXPANEL_RECORD_SESSION_PERCENT_GUEST,
} from './constants';

/**
 * Classify user as guest, experiment, or logged_in
 * Used to track amount of events for different user types
 * @param abTests - The AB tests object
 * @param userId - The user ID
 * @returns The user type object
 */
export const getUserType = (abTests: ABTests, userId: FiverrContext['userId']): { $userType: string } => {
    if (!userId) {
        return { $userType: 'guest' };
    }
    if (Object.values(abTests).some((value) => Number(value) === 2)) {
        return { $userType: 'experiment' };
    }

    return { $userType: 'logged_in' };
};

/**
 * The price up front feature is being enrolled in Australia and GB, we need to track 100% of events for users in these countries
 * @param countryCode
 * @returns true if user is in Australia or GB
 */
const inPriceUpFrontFeatureExperiment = (countryCode: FiverrContext['countryCode']): boolean =>
    countryCode === 'AU' || countryCode === 'GB';

export function getMixpanelRecordSessionPercent(
    abTests: ABTests,
    userId: FiverrContext['userId'],
    countryCode: FiverrContext['countryCode']
): number {
    // Check if user is in a fully tracked experiment
    const shouldTrackFully = Object.values(FULLY_TRACKED_EXPERIMENTS).some(
        (experiment) => Number(abTests[experiment]) === 2
    );

    if (shouldTrackFully || inPriceUpFrontFeatureExperiment(countryCode)) {
        return 100;
    }

    if (!userId) {
        return MIXPANEL_RECORD_SESSION_PERCENT_GUEST;
    }

    return MIXPANEL_RECORD_SESSION_PERCENT;
}
